import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import { Nav, NavItem, NavDropdown, MenuItem } from "react-bootstrap";

class MenuItems extends Component {
    state = {  }
    render() { 
        return (
            <React.Fragment>
                <Nav>
                    <NavItem style={{fontSize:13}}>
                        <NavLink to="/home" className="fuente-monserrat"><strong>Inicio</strong></NavLink>
                    </NavItem>
                    <NavItem style={{fontSize:13}}>
                        <NavLink to="/institucion"className="fuente-monserrat"><strong>Conócenos</strong></NavLink>
                    </NavItem>
                    <NavItem style={{fontSize:13}}>
                        <Nav pullRight={this.props.right}>
                            <NavDropdown eventKey={4} title={<a className="fuente-monserrat"><strong>Servicio</strong></a>} id="sub1" style={{marginTop:-11, fontSize:13}} className="nav-custom-left">
                                <MenuItem eventKey={2.1} style= {{padding: 8}}>
                                    <NavLink to="/ingreso" style={{fontSize:13}} className="fuente-monserrat">INSCRIPCIÓN (ADMISIÓN)</NavLink>
                                </MenuItem>
                                <MenuItem eventKey={2.1} style= {{padding: 8}}>
                                    <NavLink to="/reinscripcion" style={{fontSize:13}} className="fuente-monserrat">REINSCRIPCIONES (REGULARES)</NavLink>
                                </MenuItem>
                            </NavDropdown>
                        </Nav>
                    </NavItem>
                    <NavItem style={{fontSize:13}}>
                        <NavLink to="/extension" className="fuente-monserrat"><strong>Planes Especiales</strong></NavLink>
                    </NavItem>
                </Nav>
            </React.Fragment>
        );
    }
}
 
export default MenuItems;


// WEBPACK FOOTER //
// ./src/site/Componentes/MenuItems.jsx